import { GiCarWheel } from "react-icons/gi";

import './Spinner2.css'; // Import a CSS file to style the spinner

function Spinner2() {
  return (

        <div className="full-page-spinner">
            
      <p className="lrotate360 spin center">
      <GiCarWheel className="icon-img" style={{ width: "3rem", height: "3rem" }} />
      </p>
    </div>
  );
}

export default Spinner2;
